import { Container, Row, Col } from "react-bootstrap"
import styled from "styled-components"
import Box from "~/components/UI/Box"
import { Trans, useTranslation } from "~/i18n"
import Text from "~/components/UI/Text"
import getcdn from "~/modules/get_cdn_link"
import Img from "~/components/UI/Image"

const MyContainer = styled(Box)`
  margin-bottom: 90px;
`

const Item: React.FC<{
  image: string
  title: string
  content: string
}> = ({ image, title, content }) => {
  return (
    <Box xsStyle={{ textAlign: 'center' }} mdStyle={{ textAlign: 'left' }} padding='20px'>
      <Img src={image} width={64} height={64} alt={title} />
      <Text xsStyle={{ textAlign: 'center' }} mdStyle={{ textAlign: 'left' }} padding='8px 0' bold size={22}>
        {title}
      </Text>
      <Text xsStyle={{ textAlign: 'center' }} mdStyle={{ textAlign: 'left' }}>
        {content}
      </Text>
    </Box>
  )
}

const EasyInvest = () => {

  const [t] = useTranslation()

  return (
    <MyContainer>
      <Text xsStyle={{ padding: '10px 20px' }} mdStyle={{ padding: '0 0 30px 0' }} centered size={36} lgSize={56} mdSize={48}>
        <Trans i18nKey='Khi đầu tư trở nên thật đơn giản'></Trans>
      </Text>
      <Container>
        <Row>
          <Col md={4}>
            <Item
              content={t('Bắt đầu với số vốn nhỏ, linh hoạt, cùng Infina xây dựng thói quen tích luỹ lâu dài.')}
              title={t('Vốn khởi điểm nhỏ')}
              image={getcdn('/images/home/saving.svg')}
            />
          </Col>
          <Col md={4}>
            <Item
              content={t('Sản phẩm đầu tư được đánh giá tiềm năng sinh lời tốt, pháp lý rõ ràng, giảm thiểu rủi ro, tính thanh khoản cao.')}
              title={t('Sinh lời an toàn')}
              image={getcdn('/images/home/growth.svg')}
            />
          </Col>
          <Col md={4}>
            <Item
              content={t('Đầu tư online trên ứng dụng thông minh, giao diện thân thiện chỉ với vài thao tác chạm.')}
              title={t('Đơn giản tiện lợi')}
              image={getcdn('/images/home/simple.svg')}
            />
          </Col>
        </Row>
      </Container>
    </MyContainer>
  )
}

export default EasyInvest
